import { RegistrationStatus } from "@fieldday/fielddayportal-model"
import { SurveyAnswerType } from "@fieldday/fielddayportal-model/dist/src/model/SurveyAnswerType"
import { ScheduledActivityForView, SurveyAnswer, SurveyQuestion } from "../models/Activity"
import { NPO } from "../models/Npo"
import { OrgUnit } from "../models/OrgUnit"
import { Registration } from "../models/Registration"

export const surveyAnswerByType = (answer: SurveyAnswer, question: SurveyQuestion) => {
  switch (question.answerType) {
    case SurveyAnswerType.MultipleChoice: {
      return answer.valueAsKey
    }
    case SurveyAnswerType.Range:
    case SurveyAnswerType.StarRating: {
      return answer.valueAsNumber
    }
    default: {
      return answer.valueAsText
    }
  }
}

export const questionWithName = (question: SurveyQuestion, nonprofit?: NPO, orgUnit?: OrgUnit): string => {
  return question.question
    .replaceAll('[TEAM]', `${orgUnit?.name ?? "the Team"}`)
    .replaceAll('[NPO]', `${nonprofit?.name ?? "the nonprofit"}`)
}

export interface Survey {
  questions: SurveyQuestion[],
  answers: SurveyAnswer[],
  registrationQuestions?: SurveyQuestion[],
  registrationAnswers?: SurveyAnswer[],
}

export const buildSurvey = (
  sa: ScheduledActivityForView,
  surveyQuestions: SurveyQuestion[],
  surveyAnswers: SurveyAnswer[]
): Survey => {
  const questions = surveyQuestions.map(q => {
    return({
      ...q,
      question: q.question
        .replaceAll('[TEAM]', `${sa.orgUnit?.name ?? "your team"}`)
        .replaceAll('[NPO]', `${sa.nonProfitOrg?.name ?? "the nonprofit"}`),
    })
  })

  return {
    questions: questions,
    answers: surveyAnswers,
  }
}

export const getSurveySubmissions = (registrations: Registration[], survey: Survey): Registration[] => {
  const respondedRegistrations = new Set(survey.answers.map(answer => answer.registrationId))
  // Get only registrations that have submitted at least one survey answer.
  const submissions = registrations.filter(r => r.status === RegistrationStatus.ReviewComplete && r.id && respondedRegistrations.has(r.id))
  return submissions
}

export const getSurveyResponseRate = (submissions: Registration[], registrations: Registration[]): number => {
  return Math.round(100 * submissions.length / registrations.length)
}
